// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAlignCenterOutlinedSvg from "@fishx/icons-svg/es/asn/PAlignCenterOutlined";
import FishxIcon from '../components/FishxIcon';

var PAlignCenterOutlined = function PAlignCenterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAlignCenterOutlinedSvg
  }));
};

PAlignCenterOutlined.displayName = 'PAlignCenterOutlined';
export default React.forwardRef(PAlignCenterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAlignCenterOutlined.js
// module id = 3195
// module chunks = 0